/* eslint-disable @next/next/no-img-element */
/** @jsxImportSource @emotion/react */
import React from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { mq } from '../../../../helpers'
import { gsColors } from '../../../../styles/Variables'

// const animation = keyframes`
//   from, 0% {
//     transform: scale(1);
//   }
//   50% {
//     transform: scale(1.1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `

const scaleIn = keyframes`
  from {
    transform: translate(-50%, -50%) scale(.5, .5);
    opacity: .5;
  }
  to {
    transform:  translate(-50%, -50%) scale(2.5, 2.5);
    opacity: 0;
  }
`

const LoadingDiv = styled.div`
  text-align: center;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .circle-container {
    min-height: 200px;
    margin-top: 100px;
    height: 100%;
    width: 100%;
    position: relative;

    img {
      height: 100px;
      width: 100px;
      z-index: 3;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    
    .white-circle {
      height: 100px;
      width: 100px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #FFF;
      z-index: 2;
    }
    
    .circle {
      z-index: 0;
      top: 50%;
      left: 50%;      
      position: absolute;
      border-radius: 50%;
      background-color: ${gsColors.cobalt};
      height: 100px;
      width: 100px;
      opacity: 0;
      animation: ${scaleIn} 4s infinite cubic-bezier(.36, .11, .89, .32);
    }
  }

  p {
    color: ${gsColors.saltBox};
    margin-top: 20px;

    ${mq('min', '768px')} {
      font-size: 20px;
      margin-top: 30px;
    }
  }
`

const LoadingStep = () => {
  return (
    <LoadingDiv>
      <div className='circle-container'>
        <div className="circle" style={{ animationDelay: '-2s' }} />
        <div className="circle" style={{ animationDelay: '-1s' }} />
        <div className="circle" style={{ animationDelay: '0s' }} />
        <div className="circle" style={{ animationDelay: '1s' }} />
        <div className='white-circle' />
        <img src='/images/loading_logo.svg' alt='loading-logo' />
      </div>
    </LoadingDiv>
  )
}
export default LoadingStep